import React from 'react'
import {formatInZone, zoneNotice} from 'helpers/datetime'
import {Col, Row, List, Tag, Typography} from 'antd'
import {Spin} from 'antd'
import {useMutation, useQuery} from 'react-query'

import Item from './Item'
import * as otpQueries from '../../../queries/otp.queries'
import * as Styled from './counterview.styled'
import Link from 'components/SafeLink'

const {Title} = Typography

function OtpView({params}) {
    const otpQuery = useQuery(['id', params.id], otpQueries.getOtpById)

    const otp = otpQuery.data?.data.data

    /* G40-456: render this record's times on the clock they belong to — the
       order's, supplied by the API, or the operator's when the record has no
       order behind it. `zoneLine` names which, and says when it was inferred. */
    const fmt = (value, options = {}) =>
        formatInZone(value, otp?.order_timezone, options)
    const zoneLine = zoneNotice(otp?.order_timezone, otp?.order_timezone_source)
    if (otpQuery.isLoading) {
        return (
            <Styled.Root>
                <Spin />
            </Styled.Root>
        )
    }

    return (
        <>
            {/* G40-456 zone caption — say whose clock these times are on */}
            <div
                style={{
                    fontSize: '85%',
                    opacity: 0.75,
                    margin: '0 0 10px 8px',
                }}>
                {zoneLine}
            </div>
            <div className="order">
                <Col className="order_col">
                    <List
                        size="small"
                        bordered
                        style={{background: 'rgba(0,0,0,0.03)'}}
                        header={
                            <Title level={5} style={{height: '2.5rem'}}>
                                Basic Info
                            </Title>
                        }>
                        <Item
                            body={
                                <Link to={`/otp/${otp.id}`}>{otp.id}</Link> ||
                                'N/A'
                            }
                            title="Id "
                        />
                        <Item
                            body={
                                otp.user_id ? (
                                    <Link to={`/user/${otp.user_id}`}>
                                        {otp.user_id}
                                    </Link>
                                ) : (
                                    'N/A'
                                )
                            }
                            title="User Id "
                        />
                        <Item
                            body={otp.telephone || 'N/A'}
                            title="Telephone "
                        />
                        <Item body={otp.code || 'N/A'} title="OTP" />
                    </List>
                </Col>
                <Col className="order_col">
                    <List
                        size="small"
                        bordered
                        style={{background: 'rgba(0,0,0,0.03)'}}>
                        <Item body={otp.smshash || 'N/A'} title="Sms Hash" />
                        <Item
                            body={
                                <Tag
                                    color={
                                        otp
                                            ? otp.used === true
                                                ? 'cyan'
                                                : 'green'
                                            : null
                                    }>
                                    {otp
                                        ? otp.used === true
                                            ? 'USED'
                                            : 'UNUSED'
                                        : null}
                                </Tag>
                            }
                            title="Used"
                        />

                        <Item
                            body={
                                fmt(otp.created_at, {withParens: true}) || 'N/A'
                            }
                            title="Created On"
                        />
                        <Item
                            body={
                                fmt(otp.updated_at, {withParens: true}) || 'N/A'
                            }
                            title="Updated On"
                        />
                        <Item
                            body={
                                fmt(otp.expired_at, {withParens: true}) || 'N/A'
                            }
                            title="Expired On"
                        />
                    </List>
                </Col>
            </div>
        </>
    )
}

export default OtpView
